import { SkeletonLoader } from '../Common/SkeletonLoader';

const PaymentSkeleton = () => {
  return (
    <div className="w-full h-full flex flex-col justify-between bg-base-content">
      <div className="w-full md:w-3/5 mx-auto pb-10 md:py-10 px-6">
        <div className="flex flex-col gap-5">
          <SkeletonLoader height="h-10" />

          <div className="flex items-center gap-3">
            <SkeletonLoader height="h-[2px]" />
            <SkeletonLoader width="w-65" height="h-5" />
            <SkeletonLoader height="h-[2px]" />
          </div>

          <div className="grid grid-cols-4 gap-3">
            <SkeletonLoader height="h-14" />
            <SkeletonLoader height="h-14" />
            <SkeletonLoader height="h-14" />
            <SkeletonLoader height="h-14" />
          </div>

          <SkeletonLoader height="h-10" />

          <div className="grid grid-cols-2 gap-3">
            <SkeletonLoader height="h-10" />
            <SkeletonLoader height="h-10" />
          </div>

          <SkeletonLoader height="h-10" />
          <SkeletonLoader height="h-10 mt-6" />
        </div>
      </div>

      <div className="w-full border-t border-base-border p-6">
        <div className="w-full mx-auto flex flex-col items-center gap-4">
          <SkeletonLoader width="w-36" height="h-10" />
          <div className="flex items-center gap-4">
            <SkeletonLoader width="w-20" height="h-4" />
            <SkeletonLoader width="w-20" height="h-4" />
            <SkeletonLoader width="w-14" height="h-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSkeleton;
